import { createContext, type Context } from 'react';

import type { SetPlaceholderOverride } from './SetPlaceholderOverride';

export const PlaceholderOverrideDispatchContext: Context<SetPlaceholderOverride | null> =
	createContext<SetPlaceholderOverride | null>(null);
